import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntro from "./HeaderIntro";
import NewsLetter from "./NewsLetter";
export class GstAssesment extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro />
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
        <div className="container">
          <div class="container-fluid" data-aos="fade-up">
           

            <div class="section-header">
              <h3>GST Assessment</h3>
              <p> In accordance with GST, assessment of GST refers to
                determination of tax liability under this act. Generally people
                having a GST Registration have to file GST Returns or pay GST
                every month according to GST liability. Let all your worries be
                ours! Stay back and enjoy!</p>
            </div>
            
            </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default GstAssesment;
